module.exports = __webpack_public_path__ + "static/media/ru.1ee91d21.svg";